import React from "react";

export default function ImageCarouselLoader() {
  return (
    <div className="relative">
      {/* Scrollable Wrapper */}
      <div className="flex overflow-x-scroll scrollbar-hide">
        {[...Array(5)].map((_, index) => (
          <div
            key={index}
            className={`flex-shrink-0 w-80 h-64 sm:h-80 ${index === 0 ? "" : "ml-2"}`}
          >
            {/* Skeleton Placeholder */}
            <div className="skeleton w-full h-full rounded-lg"></div>
          </div>
        ))}
      </div>
    </div>
  );
}
